import React from "react";
import CandidatesContainer from "../Canditates/CandidatesContainer";

const Mainview = ({ data, communes, langId, isDesktop }) => {
  return (
    <div className="pb-12" style={{ paddingTop: 52 }}>
      {data.map((item, index) => (
        <CandidatesContainer
          key={index}
          data={item}
          index={index}
          langId={langId}
          isDesktop={isDesktop}
        />
      ))}
    </div>
  );
};

export default Mainview;
